// src/pages/Folder/components/Weather.tsx

import { Box } from '@mui/material'
import { useEffect, useState } from 'react'

const {
  REACT_APP_API_OPENWEATHER_APPID: APPID,
  REACT_APP_API_OPENWEATHER_LANG: LANG,
  REACT_APP_API_OPENWEATHER_UNITS: UNITS,
  REACT_APP_API_OPENWEATHER_BASECITY: BASECITY,
} = import.meta.env

type WeatherProps = {
  city: string
}

export const Weather = ({ city }: WeatherProps) => {
  if (city === '') city = BASECITY

  const [isLoaded, setLoaded] = useState(false)
  const [error, setError] = useState(null)
  const [weather, setWeather] = useState<any>([])

  useEffect(() => {
    const url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${APPID}&lang=${LANG}&units=${UNITS}`

    fetch(url)
      .then(result => result.json())
      .then(result => {
        const { main, name, weather } = result
        const { description, icon } = weather[0]
        const { temp } = main

        setWeather({ description, icon, name, temp })

        return null
      })
      .then(() => setLoaded(true))
      .catch(error => setError(error))
  }, [city])

  if (!isLoaded) return <>Wetterdaten werden geladen...</>
  if (error) return <>Keine Wetterdaten verfügbar</>

  return (
    <Box
      sx={{
        position: 'relative',
        mt: '15px',
        textAlign: 'right',
        m: '0 50px 0 0',
      }}
    >
      <Box>
        {weather.name}
        <Box
          alt={'Wetter Icon'}
          component={'img'}
          src={`https://openweathermap.org/img/wn/${weather.icon}.png`}
          sx={{ position: 'absolute', top: '-20px' }}
          title={'Wohlbefinden'}
        />
      </Box>
      <Box>
        {Math.round(weather.temp)}
        &deg;C, {weather.description}
      </Box>
    </Box>
  )
}
